"use client";
import React, { useEffect } from "react";
import PropTypes from "prop-types";

import WarningIcon from "assets/svg/small-warning.svg";

import Sidebar from "components/listing-search/sidebar";
import Content from "components/listing-search/content";
import OrderDropdown from "components/listing-search/order-dropdown";
import FromWhomTabs from "components/listing-search/from-whom-tabs";
import NothingListingCard from "components/listing-search/nothing-listing-card";
import ListingDeletedInfoCard from "components/cards/listing-deleted-info-card";
import GlobalGa4GtmSearchIdEvent from "components/gtm-load-events/globalGa4GtmSearchIdEvent";
import MapSwitchButton from "src/components/listing-search/map-switch-button";
import ProjectRadarBanner from "src/components/listing-search/project-radar-banner";
import ProjectRadarFixedBanner from "src/components/listing-search/project-radar-fixed-banner";

import styles from "./styles.module.css";

const ContentWrapper = ({
  categoryTree,
  isDeletedRedirection,
  listingData,
  projectData,
  pageType,
  listingCountItems,
  filters,
  fromWhomContent,
  isLandingPage,
}) => {
  const summaryCategory = listingData?.searchCriteria?.category?.category?.name;
  const summaryTradeType = listingData?.searchCriteria?.category?.tradeType?.name;
  const summary = `${summaryTradeType} ${summaryCategory === "Konut" ? "Ev" : summaryCategory}`;
  const { url } = listingData || {};
  const isProjectPage = pageType === "project";
  const isListingPage = pageType === "listing";
  const isViewSimilarListingTitle =
    (isListingPage && listingData?.listingCard?.total === 1 && listingData?.similarListingCard?.total > 0) ||
    (isProjectPage && projectData?.projectCards?.total === 1 && listingData?.similarListingCard?.total > 0);
  const listingName = isProjectPage ? projectData?.name : listingData?.name;
  const listingUrlPath = isProjectPage ? projectData?.url?.path : listingData?.url?.path;
  const projects = projectData?.projectCards?.records;

  const handleSetCookie = () => {
    const categoryName = listingData?.searchCriteria?.category?.category?.name;
    localStorage.setItem("last_view", categoryName);
  };

  const setLastSearchToLocalStorage = () => {
    const searchLocation = listingData?.searchCriteria?.location?.city?.id;
    const searchLocationSummary = listingData?.summary;
    const searchLocationName = listingData?.seoParentLocation?.name;
    const searchName = searchLocation ? searchLocationName : searchLocationSummary;
    const lastSearchSchema = {
      name: isProjectPage ? listingData?.name : searchName,
      url: listingData?.url?.path,
    };

    if ((summaryCategory || summaryTradeType) && localStorage) {
      localStorage.setItem("lastSearch", summary);
    }

    const lastTwoSearchStorage = JSON.parse(localStorage.getItem("last-two-search")) || [];

    if (lastTwoSearchStorage?.length >= 2) {
      if (lastSearchSchema.name) {
        lastTwoSearchStorage.shift();
        lastTwoSearchStorage.push(lastSearchSchema);
        localStorage.setItem("last-two-search", JSON.stringify(lastTwoSearchStorage));
      }
    } else {
      if (lastSearchSchema.name) {
        lastTwoSearchStorage.push(lastSearchSchema);
        localStorage.setItem("last-two-search", JSON.stringify(lastTwoSearchStorage));
      }
    }
  };

  useEffect(() => {
    handleSetCookie();
    setLastSearchToLocalStorage();
  }, []);

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.sidebarWrap}>
          <Sidebar
            listingCountItems={listingCountItems}
            listingData={listingData}
            categoryTree={categoryTree}
            filters={filters}
          />
        </div>
        <div className={styles.contentWrap}>
          {isProjectPage && projects?.length > 0 && <ProjectRadarFixedBanner />}
          <div className={styles.sortWrapper}>
            {isLandingPage ? <div /> : <MapSwitchButton url={url} />}
            <div className={styles.orderDropdown}>
              <OrderDropdown criteria={listingData?.searchCriteria} />
            </div>
          </div>
          {fromWhomContent?.length && (
            <div className={styles.fromWhomWrapper}>
              <FromWhomTabs criteria={listingData?.searchCriteria} fromWhomContent={fromWhomContent} />
            </div>
          )}
          {isProjectPage && projects?.length > 0 && <ProjectRadarBanner />}
          {isDeletedRedirection && <ListingDeletedInfoCard />}
          {(isListingPage && listingData?.listingCard?.records?.length === 0) ||
          (isProjectPage && projectData?.projectCards?.records?.length === 0) ? (
            <NothingListingCard
              criteria={listingData?.searchCriteria}
              name={listingName}
              urlPath={listingUrlPath}
              pageType={pageType}
            />
          ) : (
            <>
              <Content
                listingItems={listingData?.listingCard?.records}
                projectListing={projectData?.projectCards?.records}
                pageType={pageType}
                criteria={listingData?.searchCriteria}
                name={listingName}
                urlPath={listingUrlPath}
                isLandingPage={isLandingPage}
              />
            </>
          )}
          {isViewSimilarListingTitle && (
            <div className={styles.oneAdWrapper}>
              <WarningIcon />
              <p className={styles.oneAdinfo}>
                Arama kriterlerinize uygun başka ilan bulamadık. Kriterlerinize{" "}
                <span className={styles.fontBold}>benzer ilanlara</span> göz atabilirsiniz.
              </p>
            </div>
          )}
          {listingData?.similarListingCard?.records?.length > 0 && (
            <div className={styles.similarListingWrapper}>
              <span className={styles.similarlisting}>Benzer İlanlar</span>
              <Content
                listingItems={listingData?.similarListingCard?.records}
                pageType={pageType}
                criteria={listingData?.searchCriteria}
                name={listingName}
                urlPath={listingUrlPath}
                similarCount={listingData?.similarListingCard?.records?.length}
                isLandingPage={isLandingPage}
              />
            </div>
          )}
        </div>
      </div>
      <GlobalGa4GtmSearchIdEvent pageName="listingsearch" />
    </>
  );
};

ContentWrapper.propTypes = {
  categoryTree: PropTypes.array,
  listingData: PropTypes.object,
  pageType: PropTypes.string,
  projectData: PropTypes.object,
  isDeletedRedirection: PropTypes.bool,
  listingCountItems: PropTypes.array,
  filters: PropTypes.object,
  fromWhomContent: PropTypes.array,
  isLandingPage: PropTypes.bool,
};

export default ContentWrapper;
